var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('vs-checkbox',{attrs:{"size":"small"},on:{"change":_vm.invokeParentMethod},model:{value:(_vm.selecionadoInner),callback:function ($$v) {_vm.selecionadoInner=$$v},expression:"selecionadoInner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }